'use client'

import Page from 'pageCores/wall-of-love'

export const WallOfLoveContent = () => {
	return <Page />
}
